import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormHtmlField from 'modules/ui/editform/fields/EditFormHtmlField';
import ReviewEditService from 'app/admin/review/service/ReviewEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import FmStorageTableService from 'app/admin/fileManager/service/FmStorageTableService';
import FmBrowserTableService from 'app/admin/fileManager/service/FmBrowserTableService';
import nBossConnection from 'modules/base/service/nBossConnection';
import GradualOutputLevelCorrespondence from 'app/admin/kerdes/enum/GradualOutputLevelCorrespondence';
import ReasoningLevel from 'app/admin/kerdes/enum/ReasoningLevel';
import IncorrectAnswersBelievable from 'app/admin/kerdes/enum/IncorrectAnswersBelievable';
import ShouldBeDeleted from 'app/admin/kerdes/enum/ShouldBeDeleted';

const config = {
	key: 'reviewEditForm',
	text: 'Kérdés vélemény',
	textKey: 'review',
	service: ReviewEditService,
	icon: 'person',
	fields: [
		{
			key: 'gradualOutputLevelCorrespondence',
			text: 'A graduális kimeneti szintnek megfelelő a kérdés?',
			textKey: 'gradualOutputLevelCorrespondence',
			component: EditFormSelectField,
			type: 'enum',
			readOnly: true,
			items: Object.keys(GradualOutputLevelCorrespondence).map(key => { return { label: GradualOutputLevelCorrespondence[key], value: key }; })
		},
		{
			key: 'reasoningLevel',
			text: 'Milyen gondolkodást mér a kérdés?',
			textKey: 'reasoningLevel',
			component: EditFormSelectField,
			type: 'enum',
			readOnly: true,
			items: Object.keys(ReasoningLevel).map(key => { return { label: ReasoningLevel[key], value: key }; })
		},
		{
			key: 'clearQuestion',
			text: 'A kérdés világos, egyértelmű?',
			textKey: 'clearQuestion',
			component: EditFormSelectField,
			type: 'enum',
			readOnly: true,
			items: [{ label: 'Igen', value: true }, { label: 'Nem', value: false }]
		},
		{
			key: 'incorrectAnswersBelievable',
			text: 'A helytelen válaszlehetőségek milyen minőségűek?',
			textKey: 'incorrectAnswersBelievable',
			component: EditFormSelectField,
			type: 'enum',
			readOnly: true,
			items: Object.keys(IncorrectAnswersBelievable).map(key => { return { label: IncorrectAnswersBelievable[key], value: key }; })
		},
		{
			key: 'grammarProblems',
			text: 'Nyelvtani hiba, vagy nyelvhelyességi hiba van-e?',
			textKey: 'grammarProblems',
			component: EditFormSelectField,
			type: 'enum',
			readOnly: true,
			items: [{ label: 'Van', value: true }, { label: 'Nincs', value: false }]
		},
		{
			key: 'shouldBeDeleted',
			text: 'Törölni kell-e a kérdést',
			textKey: 'shouldBeDeleted',
			component: EditFormSelectField,
			type: 'enum',
			readOnly: true,
			items: Object.keys(ShouldBeDeleted).map(key => { return { label: ShouldBeDeleted[key], value: key }; })
		},
		{
			key: 'comments',
			text: 'Megjegyzések',
			textKey: 'comments',
			component: EditFormHtmlField,
			storageService: FmStorageTableService,
			browserService: FmBrowserTableService,
			getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
			readOnly: true,
		},
	]
};

function ReviewEditForm() {
	return <EditFormPage config={config} />;
}

export default ReviewEditForm;